module.exports = __webpack_public_path__ + "img/producto1.90f95835.jpg";